import { React, forwardRef } from "react";
import classes from "./Input.module.css";

const Input = forwardRef((props, ref) => (
  <input
    className={
      props.error ? `${classes.Input} ${classes.Error}` : classes.Input
    }
    {...props}
    ref={ref}
  />
));

export default Input;
